'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ValueSet = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValueSet = exports.ValueSet = function () {
    function ValueSet(data) {
        (0, _classCallCheck3.default)(this, ValueSet);

        var prototype = (0, _getPrototypeOf2.default)(this);
        var defaultData = prototype.constructor.defaultData || {};
        this._type = prototype.constructor.name;
        this._isValueSet = true;
        this._data = (0, _extends3.default)({}, defaultData, data);
        this._configurables = prototype.constructor.configurables || [];
    }

    (0, _createClass3.default)(ValueSet, [{
        key: 'toQueryFragment',
        value: function toQueryFragment() {
            throw new Error('Not Implemented for ValueSet.');
        }
    }, {
        key: 'type',
        get: function get() {
            return this._type;
        }
    }, {
        key: 'isValueSet',
        get: function get() {
            return this._isValueSet;
        }
    }, {
        key: 'data',
        get: function get() {
            return this._data;
        }
    }]);
    return ValueSet;
}();

exports.default = ValueSet;